import { wait } from 'global/common/globalUtils';
import salesforceIframeSetup from 'global/thirdParties/salesforceIframeSetup';

const excludedUtmSources = [
	'b2c_promo',
	'b2c_behav',
	'b2c_lcl',
	'b2c_rsrch',
	'b2c_info',
	'b2b_promo',
	'b2b_behav',
	'b2b_lcl',
	'b2b_rsrch',
	'b2b_info',
];

const shouldShowNewsletterBox = () => {
	const params = new URL(document.location).searchParams;
	const qs = params.get('utm_source');
	return (
		localStorage.getItem('mt_slideIn') !== 'false' &&
		!document.getElementById('fsrFullScreenContainer') &&
		!excludedUtmSources.includes(qs)
	);
};

const enableAfterClose = () => {
	const prevDate = localStorage.getItem('mt_timestamp_hide');
	if (prevDate && localStorage.getItem('mt_slideIn') === 'false') {
		const currentData = Date.now();
		const totalTime = (currentData - Number(prevDate)) / 1000 / 60 / 60 / 24;
		if (totalTime >= 60) {
			localStorage.removeItem('mt_timestamp_hide');
			localStorage.setItem('mt_slideIn', 'true');
		}
	}
};

const newsletterBox = elem => {
	addPostMessageListener(receiveMessage);
	enableAfterClose();
	if (shouldShowNewsletterBox()) {
		setupNewsletterBox(elem);
	}

	salesforceIframeSetup('newsletterBoxIframe');
};

const setupNewsletterBox = elem => {
	elem.querySelector('.newsletter-box__close').onclick =
		closeButtonWasClicked.bind(this, elem);
	if (localStorage.getItem('mt_slideIn') === 'true') {
		elem.classList.add('newsletter-box--visible');
	} else {
		const timestamp = localStorage.getItem('mt_timestamp') || Date.now();
		localStorage.setItem('mt_timestamp', timestamp);
		countdownToShow(elem, 15);
	}
};

const countdownToShow = async (elem, maxRuns) => {
	const prevTime = Number(localStorage.getItem('mt_timestamp'));
	const totalTime = (Date.now() - prevTime) / 1000;
	if (maxRuns <= 0 || totalTime >= 60) {
		slideInNewsletterBox(elem);
	} else {
		await wait(1000);
		countdownToShow(elem, maxRuns - 1);
	}
};

const slideInNewsletterBox = elem => {
	elem.classList.add('newsletter-box--visible', 'newsletter-box--slide');
	localStorage.setItem('mt_slideIn', 'true');
	localStorage.removeItem('mt_timestamp');
};

const closeButtonWasClicked = elem => {
	if (localStorage.getItem('mt_slideIn') === 'true') {
		localStorage.setItem('mt_slideIn', 'false');
		localStorage.removeItem('mt_timestamp');
		localStorage.setItem('mt_timestamp_hide', Date.now().toString());
	}
	elem.classList.add('newsletter-box--slide');
	elem.classList.remove('newsletter-box--visible');
};

const addPostMessageListener = cb => {
	window.addEventListener('message', cb, false);
};

const receiveMessage = event => {
	if (event.origin === 'https://officedepot.emsecure.net') {
		localStorage.setItem('mt_slideIn', 'false');
		localStorage.removeItem('mt_timestamp');
	}
};

export { newsletterBox, addPostMessageListener, receiveMessage };
